<template>{{ durationString }}</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  seconds: {
    type: Number,
    required: true,
  },
});

const durationString = computed(() => {
  const h = Math.floor(props.seconds / 3600);
  const m = Math.floor(props.seconds / 60) % 60;
  const s = props.seconds % 60;
  const hs = h > 0 ? [`${h}h`] : [];
  const ms = m > 0 ? [`${m}m`] : [];
  const ss = s > 0 ? [`${s}s`] : [];
  return [...hs, ...ms, ...ss].join(' ');
});
</script>
